import axios from 'axios'
import { DOWNLOAD_PARTE_FECHAMENTO_CAIXA } from '../../types'
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil'
import { URL } from '../../../util/ambienteActions';
import { montarURLFiltro } from '../../../util/filtros';

export default function downloadParteFechamentoCaixa(idEmpresa, size, from, filtrosAdicionados) {
  const urlFiltros = montarURLFiltro(filtrosAdicionados);
  const url = `${URL}/fechamento-caixa-usuario/empresa/${idEmpresa}`;
  const urlReq = `${url}?size=${size}&from=${from}&${urlFiltros}`;
  
  return dispatch => axios.get(urlReq, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: DOWNLOAD_PARTE_FECHAMENTO_CAIXA,
      payload: response
    })
  );
}
